<template>
	<div>
		<PagesHeading />
		<div id="news" class="container" :class="{ 'loading-app-style': loading }">
			<div class="py-5" v-if="loading" style="display: flex; align-items: center; justify-content: center">
				<div  class="loader"></div>
			</div>
	
			<div v-else class="row mt-5">
				<div v-for="(oneNew, index) in news" :key="index" class="col-12 col-sm-6 col-lg-4 mb-4">
					<router-link :to="{name: 'news-view', params:{slug:oneNew.slug} }">
						<div class="card">
							<img :src="oneNew.primaryImage.url" style="object-fit: cover; height: 240px;" class="card-img-top">
							<div class="card-body pt-3 d-flex flex-column justify-content-between">
								<div>
									<span v-html="oneNew.summary" class="card-text"></span>
								</div>
								<span>
									<i class="fa fa-angle-double-right mr-1 text-secondary"></i>
									<a class="text-secondary" >
										{{$t('common.read-more')}}
									</a>
								</span>
							</div>
						</div>
					</router-link>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import PagesHeading from '@/components/PagesHeading.vue';
import { mapActions, mapState } from 'vuex';
export default {
	components: { 
		PagesHeading
	},
	data() {
		return {
			loading: true
		}
	},
	computed: {
		...mapState({
			news: state => state.news.news
		})
	},
	methods: {
		...mapActions('news', ['fetchNews']),
		fetch() {
			if (!this.news[0]) {
				this.fetchNews()
					.finally(() => { this.loading = false });
			}	else {
				this.loading = false;
			}
		}
	},
	created() {
		this.fetch();
	}
}
</script>
<style scoped>
body {
	background-color: white;
}
.card {
	border: none;
	border-bottom: 10px solid #FCAD4D;
	box-shadow: -1px 2px 8px rgba(0, 0, 0, 0.25);
	transition: all 0.5s ease, transform 0.5s ease;
	height: 100%;
}
.card:hover {
	box-shadow: -1px 2px 18px rgba(0, 0, 0, 0.25);
	transform:  translateY(-12px);
}
a {
	text-decoration: none !important;
}

.card-body span {
	color: #8c8c8c;
}

a.text-secondary:hover {
	color: #FCAD4D !important;
}
.card-text *{
	font-size: 16px !important;
}

.h-100 {
	height: 100% !important;
}

html[dir='rtl'] .card-body {
	text-align: right;
}

html[dir='rtl'] .card-body i {
	transform: rotate(180deg);
}

@media (max-width:520px) {
	.h-100 {
		height: 90% !important;
	}
}
</style>
